import React, { FC, memo } from 'react';
import cls from './DaysModePosition.module.css';
import classNames from 'classnames';
import { PositionIItem } from '../../../../../../UI/PositionItem/PositionIItem';
import moment from 'moment';
import { useSelector } from 'react-redux';

export const DayItemPosition = memo(
    ({ month, position, isPlanFact, currentDay, currentMonths }) => {
        const nowDate = moment().format('DD.MM.YYYY');

        const { settings } = useSelector((state) => state.gantReducer);

        const isShowPosition = !settings.isShowMHD && position?.type !== 'labor';

        let isPlanFactShow = true;
        const positionStartDate = moment(position.planned.start_date).format('DD.MM.YYYY');

        if (isPlanFact) {
            isPlanFactShow = isPlanFact && !!position?.planned.start_date;
        }

        if (!isPlanFactShow) {
            return null;
        }

        if (isShowPosition) {
            return null;
        }

        return (
            <>
                {month.days.map((day) => (
                    <div
                        key={day.day}
                        className={classNames(cls.day, {
                            [cls.factWrapper]: isPlanFact,
                            [cls.weekend]: day.isWeekend,
                            [cls.nowDate]: day.date === nowDate,
                        })}
                    >
                        {day.date === positionStartDate && (
                            <PositionIItem isPlanFact={isPlanFact} position={position} />
                        )}
                    </div>
                ))}
            </>
        );
    }
);
